export default __webpack_public_path__ + "media/images/icons/icon-document-b85e71d553aebcc720e0a99dacc422e2.svg";